/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetDimensionDetailsModel {
    getFixupPrototypeFunction() { return BudgetDimensionDetailsModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetDimensionDetailsModel>): BudgetDimensionDetailsModel {
        let obj = Object.assign(new BudgetDimensionDetailsModel(), model);
        BudgetDimensionDetailsModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetDimensionDetailsModel>): BudgetDimensionDetailsModel {
        if (!model) return null;
        return BudgetDimensionDetailsModel.newInstance(<BudgetDimensionDetailsModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetDimensionDetailsModel) {
        if (!obj) return;

        models.BudgetDimensionDetailsModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetDimensionDetailsModel): boolean {
        Object.setPrototypeOf(obj, BudgetDimensionDetailsModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Dimension ID for the budget. This is a unique ID and can be retrieved using the List Dimensions API.
     */
    sys_id: string;

    /**
     * Dimension name for the budget. This is a unique name and can be retrieved using the List Dimensions API.
     */
    name: string;

    /**
     * Dimension value for the budget. This is a unique value and can be retrieved using.
     */
    values: Array<string>;

    /**
     * List of grouping rule IDs to be associated with the budget. This is a unique ID and can be retrieved using the List Grouping Rules API.
     */
    grouping_rule_ids: Array<string>;

    /**
     * Entity type for the dimension. This is a unique entity type and can be retrieved.
     */
    entity: string;

}
